import { render, staticRenderFns } from "./ownerRepairs.vue?vue&type=template&id=2907be61&scoped=true"
import script from "./ownerRepairs.vue?vue&type=script&lang=js"
export * from "./ownerRepairs.vue?vue&type=script&lang=js"
import style0 from "./ownerRepairs.vue?vue&type=style&index=0&id=2907be61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2907be61",
  null
  
)

export default component.exports